import { render, staticRenderFns } from "./JudgeStepTwo.vue?vue&type=template&id=79e92c72"
import script from "./JudgeStepTwo.vue?vue&type=script&lang=js"
export * from "./JudgeStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports